<template>
  <div class="card-item p-3">
    <div class="contact-form-action">
      <h3 class="title mb-3">Kredi  : {{credit | toCurrency}} </h3>
      <div class="form-box">
        <div class="form-group">
          <div class="container">
            <base-edit-input
                v-model="amount"
                :rules="'required|min_value:1'"
                :type="'number'"
                :label="'Miktar'">
            </base-edit-input>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <button @click="remove" class="theme-btn theme-btn-danger-rgb" type="button">Çıkar</button>
        <button @click="add" class="theme-btn" type="button">Ekle</button>
      </div>
    </div>
  </div>
</template>

<script>
import BaseEditInput from "../base/BaseEditInput";
import messagePopupManager from "../../util/messagePopupManager";
export default {
  name: "agencyCredit",
  components: {BaseEditInput},
  computed:{
    credit:{
      get(){
        return this.$store.getters.getCredit;
      },
    }
  },
  methods:{
    add(){
      messagePopupManager.showQuestion(()=>{
        this.$store.dispatch("addCredit",this.amount)
        // this.amount = 0;
      },"Kredi eklemek istediğinize emin misiniz?")

    },
    remove(){
      messagePopupManager.showQuestion(()=>{
        this.$store.dispatch("removeCredit",this.amount)
        // this.amount = 0;
      },"Kredi azaltmak istediğinize emin misiniz?")

    },
  },
  data:function (){
    return{
      amount:0
    }
  }
}
</script>

<style scoped>
/*.theme-btn{*/
/*  color: white!important;*/
/*}*/
</style>